<template>
    <div>
        <el-skeleton :loading="loading" :rows="16" animated>
            <el-page class="about-page" :bannerImageUrl="bannerImageUrl">
                <div class="company-profile">
                    <pane-title class="pane" title="公司概况" subTitle="COMPANY PROFILE" />
                    <div class="profile-section">
                        <div class="profile-content">
                            <div class="profile-image">
                                <img :src="profileInfo.pcImgUrl" />
                            </div>
                            <div class="profile-text">
                                <div class="profile-title">{{ profileInfo.title }}</div>
                                <div class="profile-description">
                                    <p v-for="(paragraph, pIndex) in (profileInfo.description || '').split('|')"
                                        :key="pIndex" style="margin: 0; margin-bottom: 0.75rem;"
                                        class="profile-description-paragraph">{{ paragraph }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="company-positioning">
                    <pane-title class="pane" title="公司定位" subTitle="COMPANY POSITIONING" />
                    <div class="profile-image-list">
                        <div :key="index" v-for="(item, index) in profileImageList" class="profile-image-item">
                            <img :src="item.pcImgUrl" />
                            <div class="content">
                                <div class="title">{{ item.title }}</div>
                                <div class="description">{{ item.description }}</div>
                                <div class="divider"></div>
                                <div class="content-text">
                                    <p v-for="(paragraph, pIndex) in (item.content || '').split('|')" :key="pIndex">{{
                                        paragraph
                                    }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="shareholder-strength">
                    <pane-title class="pane" title="发起股东" subTitle="INITIATING SHAREHOLDER" />
                    <div class="shareholder-list">
                        <div v-for="(item, index) in shareholderList" :key="index" class="shareholder-item">
                            <div class="shareholder-image">
                                <div class="shareholder-image-content">
                                    <img :src="item.pcImgUrl" />
                                </div>
                            </div>
                            <div class="shareholder-text">
                                <div v-if="!!item.title" class="shareholder-title">{{ item.title || '' }}</div>
                                <div class="shareholder-description">
                                    <p v-for="(paragraph, pIndex) in (item.description || '').split('|')" :key="pIndex">
                                        {{
                                            paragraph
                                        }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="core-team">
                    <pane-title class="pane" title="核心团队" subTitle="CORE TEAM" />
                    <div class="team-list">
                        <div v-for="(item, index) in teamList" :key="index" class="team-item">
                            <div class="team-avatar">
                                <img :src="item.pcImgUrl" />
                            </div>
                            <div class="team-info">
                                <div class="team-title">{{ item.title }}</div>
                                <div class="team-description">{{ item.description }}</div>
                                <div class="team-content">
                                    <p v-for="(paragraph, pIndex) in (item.content || '').split('|')" :key="pIndex">{{
                                        paragraph
                                    }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="team-list-mobile">
                        <div v-for="(item, index) in teamList" :key="index" class="team-item">
                            <div class="team-item-top">
                                <div class="team-avatar">
                                    <img :src="item.pcImgUrl" />
                                </div>
                                <div class="team-info">
                                    <div class="team-title">{{ item.title }}</div>
                                    <div class="team-description">{{ item.description }}</div>
                                </div>
                            </div>
                            <div class="team-content">
                                <p v-for="(paragraph, pIndex) in (item.content || '').split('|')" :key="pIndex">{{
                                    paragraph
                                }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="expert">
                    <pane-title class="pane" title="外部专家团队" subTitle="EXTERNAL EXPERT CONSULTANTS" />

                    <div class="expert-title">{{ $t('about.expertTitle') }}</div>
                    <div class="expert-list">
                        <div class="expert-item" v-for="(item, index) in expertList" :key="index">
                            <div class="expert-top">
                                <div class="expert-avatar">
                                    <img :src="item.pcImgUrl" />
                                </div>
                                <div class="expert-info">
                                    <div class="expert-name">{{ item.title }}</div>
                                    <div class="expert-desc">{{ item.description }}</div>
                                </div>
                            </div>
                            <div class="expert-content">
                                <p v-for="(paragraph, pIndex) in (item.content || '').split('|')" :key="pIndex">{{
                                    paragraph
                                }}</p>
                            </div>
                            <div class="expert-gradient-line"></div>
                        </div>
                    </div>
                </div>
                <div class="culture">
                    <pane-title class="pane" title="企业文化" subTitle="COMPANY CULTURE" />
                    <swiper :options="swiperOption">
                        <swiper-slide v-for="(item, index) in cultureList" :key="index" class="culture-item">
                            <div class="culture-img" @click="showLargeImage(item.pcImgUrl)">
                                <img :src="item.pcImgUrl" alt="" />
                            </div>
                            <!-- <div class="culture-title">{{ item.title }}</div> -->
                            <!-- <div class="culture-desc">{{ item.description }}</div> -->
                        </swiper-slide>
                    </swiper>
                </div>
            </el-page>
        </el-skeleton>

        <el-dialog :visible.sync="dialogVisible" :append-to-body="true" :modal-append-to-body="false"
            custom-class="image-preview-dialog" :show-close="true" :close-on-click-modal="true"
            :close-on-press-escape="true" width="60%" height="80%">
            <div class="image-container">
                <img :src="currentImage" />
            </div>
        </el-dialog>
    </div>
</template>

<script>
import PaneTitle from '../../components/PaneTitle/PaneTitle.vue';
export default {
    name: "about",
    components: { PaneTitle },


    data() {
        return {
            loading: true,
            bannerImageUrl: '',
            profileInfo: {
                pcImgUrl: null,
                title: null,
                description: null
            },
            profileImageList: [],
            shareholderList: [],
            teamList: [],
            expertList: [],
            cultureList: [],
            dialogVisible: false,
            currentImage: '',
            swiperOption: {
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false
                },
                // loop: true, // 循环滚动
                slidesPerView: 'auto',
                spaceBetween: 16,
                centeredSlides: true,
                // observer: true,         // 监听自身变化
                // observeParents: true,   // 监听父级变化
                // watchOverflow: true,
                freeMode: true,

                breakpoints: {
                    768: {
                        slidesPerView: 4,
                        centeredSlides: false,

                    }
                }
                // pagination: {
                //     el: '.swiper-pagination',
                //     clickable: true
                // },
            },
        }
    },
    computed: {
        lang() {
            return this.$i18n.locale;
        },
        newsPageNo() {
            return Math.ceil(this.newsData.length / this.pageSize);
        },
        currentTrendsList() {
            const start = (this.currentPage - 1) * this.pageSize;
            const end = start + this.pageSize;
            return this.trendsList.slice(start, end)
        },
    },
    methods: {
        jumpDetail(item) {
            const link = item.jumpUrl;
            if (link === 'local') {
                window.open('/news-detail/' + item.id);
            } else if (link) {
                window.open(link)
            }
        },
        configData(record) {
            this.profileInfo = (record['21'] && record['21'][0]) || {}
            this.profileImageList = (record['211'] && record['211'] || []).sort((a, b) => a.sort - b.sort)
            this.shareholderList = (record['22'] && record['22'] || []).sort((a, b) => a.sort - b.sort)
            this.teamList = (record['23'] && record['23'] || []).sort((a, b) => a.sort - b.sort)
            this.expertList = (record['24'] && record['24'] || []).sort((a, b) => a.sort - b.sort)
            this.cultureList = (record['25'] && record['25'] || []).sort((a, b) => a.sort - b.sort)
        },
        getData(language) {
            this.$http.getOnlyContent({
                itemType: '2',
                platform: 'pc',
                language
            }).then(res => {
                this.loading = false;
                this.bannerImageUrl = res.imageMaps['20'] && res.imageMaps['20'][0] && res.imageMaps['20'][0].imgUrl
                this.configData(res.crmOweContentMaps)
            });
        },
        getDataByLang(lang) {
            if (lang === 'zh') {
                this.getData('china');
            } else {
                this.getData('english');
            }
        },
        showLargeImage(url) {
            this.currentImage = url;
            this.dialogVisible = true;
        }
    },
    watch: {
        "$i18n.locale": {
            immediate: true,
            handler(v) {
                this.getDataByLang(v);
            }
        },
    }
}
</script>

<style scoped lang="less">
.about-page {
    .pane {
        padding: 3rem 0;
    }

    .company-positioning {
        padding-bottom: 3rem;
    }


    .profile-section {
        padding: 0 15rem;
        //   margin-bottom: 1rem;

        .profile-content {
            display: flex;
            background: #FFF;
            box-shadow: 0px 4px 30px -2px rgba(3, 118, 152, 0.10);
            padding: 2rem 3rem;
        }

        .profile-image {
            flex: 38;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
                width: 13.75rem;
                height: auto;
                object-fit: contain;
            }
        }

        .profile-text {
            flex: 52;
            display: flex;
            flex-direction: column;
            gap: 1rem;
        }

        .profile-title {
            color: #333;
            font-family: "Source Han Sans CN";
            font-size: 1rem;
            font-style: normal;
            font-weight: 700;
            line-height: 2rem;
        }

        .profile-description {
            color: #333;
            text-align: justify;
            font-family: "Source Han Sans CN";
            font-size: 1rem;
            font-style: normal;
            font-weight: 400;
            line-height: 2rem;
        }
    }

    .profile-image-list {
        padding: 0 15rem;
        display: flex;
        flex-wrap: wrap;
        gap: 1rem;

        .profile-image-item {
            width: calc(50% - 0.5rem);
            overflow: hidden;
            transition: transform 0.3s ease;
            position: relative;

            &:hover {
                transform: scale(1.02);
            }

            img {
                z-index: 0;
                width: 100%;
                height: 100%;
                object-fit: cover;
                position: absolute;
            }

            .content {
                position: relative;
                //  background: linear-gradient(135deg, rgba(30, 90, 215, 0.50) 0.46%, rgba(11, 11, 128, 0.50) 99.53%);
                padding: 2rem;
                height: 100%;
                display: flex;
                flex-direction: column;

                .title {
                    color: #FFF;
                    font-family: "Source Han Sans CN";
                    font-size: 1.25rem;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 2rem;
                }

                .description {
                    color: #FFF;
                    font-family: "Source Han Sans CN";
                    font-size: 2rem;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 2rem;
                    margin: 1.5rem 0 1rem;
                }

                .divider {
                    width: 4.6875rem;
                    height: 0.0625rem;
                    background: #FFF;
                    margin: 1.5rem 0;
                }

                .content-text {
                    color: #FFF;
                    text-align: justify;
                    font-family: "Source Han Sans CN";
                    font-size: 1rem;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 1.875rem;

                    p {
                        margin: 0;
                        margin-bottom: 1rem;

                        &:last-child {
                            margin-bottom: 0;
                        }
                    }
                }
            }
        }
    }


    .shareholder-strength {
        background-image: url('../../assets/fqgd_bg.png');
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        padding-bottom: 3rem;
    }


    .shareholder-list {
        padding: 0 15rem;
        display: flex;
        flex-direction: column;
        gap: 1rem;

        .shareholder-item {
            display: flex;
            padding: 2rem 3rem;
            gap: 3rem;
        }

        .shareholder-image {
            flex: 4;
            overflow: hidden;
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;

            &-content {
                background-color: white;
                padding: 3.625rem 3rem;
                box-shadow: 0px 4px 30px -2px rgba(13, 20, 138, 0.10);

                img {
                    display: block;
                    width: 100%;
                    height: auto;
                    object-fit: contain;
                }
            }
        }

        .shareholder-text {
            flex: 6;
            display: flex;
            flex-direction: column;
        }

        .shareholder-title {
            margin-bottom: 0.75rem;
            font-weight: bolder;
        }

        .shareholder-description {
            color: #333;
            text-align: justify;
            font-size: 1rem;
            font-style: normal;
            font-weight: 400;
            line-height: 2rem;

            p {
                margin: 0;
                margin-bottom: 0.75rem;

                &:last-child {
                    margin-bottom: 0;
                }
            }
        }
    }

    .team-list-mobile {
        display: none;
    }

    .team-list {
        padding: 0 15rem;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        row-gap: 2.5rem;
        column-gap: 5rem;
        align-items: stretch;

        .team-item {
            display: flex;
            flex-direction: column;
            align-items: center;
        }

        .team-avatar {
            width: 8.375rem;
            height: 8.375rem;
            border-radius: 8.375rem;
            flex-shrink: 0;
            overflow: hidden;
            margin-bottom: -0.6rem;
            border: 0.6rem solid white;
            z-index: 1;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }

        .team-info {
            width: 100%;
            background-color: #F1F5FC;

            padding: 1.25rem 2.88rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            height: 100%;
            min-height: 24rem;
            border-top-left-radius: 0.6rem;
            border-bottom-right-radius: 0.6rem;
        }

        .team-title {
            color: #000;
            text-align: center;
            font-size: 1.5rem;
            font-style: normal;
            font-weight: 700;
            line-height: 2rem;
            margin-bottom: 0.56rem;
        }

        .team-description {
            color: var(--666666, #666);
            text-align: center;
            font-size: 1rem;
            font-style: normal;
            font-weight: 400;
            line-height: 1.5rem;
            margin-bottom: 1.88rem;
        }

        .team-content {
            color: var(--333333, #333);
            text-align: justify;
            font-size: 1rem;
            font-style: normal;
            font-weight: 400;
            line-height: 1.875rem;

            p {
                margin: 0;
                margin-bottom: 0.75rem;

                &:last-child {
                    margin-bottom: 0;
                }
            }
        }
    }

    .expert {
        padding: 0 15rem;
        margin-bottom: 3rem;

        .expert-title {
            color: var(--primary-color);
            font-size: 1rem;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
            margin: 0 0 2.87rem;
        }
    }

    .expert-list {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        row-gap: 2.5rem;
        column-gap: 5rem;
        align-items: stretch;

        .expert-item {
            display: flex;
            flex-direction: column;
            background: #FFF;
            position: relative;
        }

        .expert-top {
            display: flex;
            gap: 1.25rem;
            margin-bottom: 2rem;
        }

        .expert-avatar {
            flex-shrink: 0;
            width: 6.25rem;
            height: 6.25rem;
            border-radius: 50%;
            overflow: hidden;
            border: 2px solid rgba(11, 11, 128, 0.20);

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }

        .expert-info {
            display: flex;
            flex-direction: column;
            justify-content: center;
        }

        .expert-name {
            font-size: 1.25rem;
            font-weight: 700;
            color: #333;
        }

        .expert-desc {
            font-size: 0.875rem;
            font-weight: 400;
            color: #666;
        }

        .expert-content {
            font-size: 1rem;
            font-weight: 400;
            color: #333;
            text-align: justify;
            margin-bottom: 2rem;

            p {
                margin: 0;
                line-height: 1.875rem;

                &:last-child {
                    margin-bottom: 0;
                }
            }
        }

        .expert-gradient-line {
            height: 2px;
            position: absolute;
            bottom: 0;
            width: 100%;
            background: linear-gradient(135deg, #1E5AD7 0.46%, #0B0B80 99.53%);
        }
    }

    .culture {
        background: #F1F3FA;
        padding-bottom: 8rem;
    }

    .culture-list {
        //  display: flex;
        //flex-direction: row;
        //gap: 1.25rem;
        //overflow-x: auto;
        //overflow-y: hidden;
        //scrollbar-width: none;
        //-ms-overflow-style: none;
        //padding: 0 2rem;
    }

    .culture-list::-webkit-scrollbar {
        // display: none;
    }

    .culture-item {
        // min-width: 31.75rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        transition: transform 0.3s ease;

        &:hover {
            transform: scale(1.02);
        }
    }

    .culture-img {
        width: 100%;
        aspect-ratio: 508/307;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: transform 0.3s;

        &:hover {
            transform: scale(1.02);
        }
    }

    .culture-img img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
    }
}


/deep/ .image-preview-dialog {
    .el-dialog__body {
        padding: 0;
        background: #000;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
    }

    .el-dialog__header {
        padding: 0;
        background: transparent;
        position: relative;
        z-index: 1;
    }

    .el-dialog__headerbtn {
        top: 20px;
        right: 20px;
        color: #fff;
        z-index: 2;
        position: fixed;

        .el-icon-close {
            color: white;
        }
    }

    .image-container {
        width: 100%;
        aspect-ratio: 16/9;
        position: relative;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
            max-width: 100%;
            max-height: 100%;
            width: auto;
            height: auto;
            object-fit: contain;
        }
    }
}

/* 小屏幕（移动端） */
@media screen and (max-width: 767px) {
    .about-page {
        .pane {
            padding: 2rem 0;
        }

        .company-positioning {
            padding-bottom: 2rem;
        }

        .profile-section {
            padding: 0;

            .profile-content {
                display: flex;
                background: #FFF;
                box-shadow: 0px 4px 30px -2px rgba(3, 118, 152, 0.10);
                padding: 2.5rem 1rem 1.5rem;
                flex-direction: column;
            }

            .profile-image {
                img {
                    width: 10rem;
                }
            }

            .profile-title {
                font-size: 1.166rem;
                margin-top: 3rem;

            }

            .profile-description {
                font-size: 1.16rem;
                line-height: 2.25rem;
            }
        }

        .profile-image-list {
            padding: 0;
            display: flex;
            flex-direction: column;
            gap: 1rem;

            .profile-image-item {
                width: 100%;

                .content {
                    padding: 1rem;

                    .content-text {
                        font-size: 1.16rem;
                        line-height: 2.25rem;
                    }
                }
            }
        }


        .shareholder-strength {
            margin: 0 -1.333rem;
        }


        .shareholder-list {
            padding: 0;

            .shareholder-item {
                background-color: white;
                margin: 0 1.333rem;
                flex-direction: column;
                gap: 1rem;
            }

            .shareholder-image {
                &-content {
                    padding: 3rem;
                }
            }


            .shareholder-text {
                font-size: 1.16667rem;
            }

            .shareholder-description {
                font-size: 1.16667rem;
                line-height: 2rem;
            }
        }

        .team-list {
            display: none;
        }

        .team-list-mobile {
            padding: 0;
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            row-gap: 1rem;
            column-gap: 1rem;

            .team-item {
                display: flex;
                flex-direction: column;

                &-top {
                    background-image: url('../../assets/team_bg.png');
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    padding: 0.5rem 1rem;
                    display: flex;
                    align-content: center;

                    .team-avatar {
                        width: 6.8rem;
                        height: 6.8rem;
                        border-radius: 6.8rem;
                        flex-shrink: 0;
                        overflow: hidden;
                        border: 2px solid white;
                        z-index: 1;

                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                        }
                    }

                    .team-info {
                        padding: 0 1.75rem;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;

                        .team-title {
                            color: white;
                            font-size: 1.333rem;
                            font-style: normal;
                            font-weight: 700;
                            line-height: 2rem;
                            margin-bottom: 0.5rem;
                        }

                        .team-description {
                            color: fade(white, 80%);
                            font-size: 1rem;
                            font-style: normal;
                            font-weight: 400;
                            line-height: 1.75rem;
                        }

                    }
                }
            }

            .team-content {
                padding: 1.75rem 1rem;
                background-color: fade(#0B0B80, 10);
                color: var(--333333, #333);
                text-align: justify;
                font-family: "Source Han Sans CN";
                font-size: 1.16667rem;
                font-style: normal;
                font-weight: 400;
                line-height: 2rem;
                /* 175% */

                p {
                    margin: 0;
                    margin-bottom: 0.75rem;

                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            }
        }

        .expert {
            padding: 0;
            margin-bottom: 3rem;

            .expert-title {
                color: var(--primary-color);
                font-size: 1.16667rem;
                font-style: normal;
                font-weight: 500;
                line-height: normal;
                margin: 0 0 2rem;
            }
        }

        .expert-list {
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            row-gap: 2.5rem;
            column-gap: 5rem;
            align-items: stretch;

            .expert-item {
                display: flex;
                flex-direction: column;
                background: #FFF;
                position: relative;
            }

            .expert-top {
                display: flex;
                gap: 1.25rem;
                margin-bottom: 0.5rem;
            }

            .expert-avatar {
                flex-shrink: 0;
                width: 5.25rem;
                height: 5.25rem;
                border-radius: 50%;
                overflow: hidden;
                border: 2px solid rgba(11, 11, 128, 0.20);

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }

            .expert-info {
                display: flex;
                flex-direction: column;
                justify-content: center;
            }

            .expert-name {
                font-size: 1.3333rem;
                font-weight: 700;
                color: #333;
            }

            .expert-desc {
                font-size: 1.125rem;
                font-weight: 400;
                color: #666;
            }

            .expert-content {
                font-size: 1.16667rem;
                font-weight: 400;
                color: #333;
                text-align: justify;
                margin-bottom: 1.75rem;
                margin-left: 6.5rem;

                p {
                    margin: 0;
                    line-height: 2.25rem;

                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            }

            .expert-gradient-line {
                margin-left: 6.5rem;
                height: 1px;
                position: absolute;
                bottom: 0;
                width: calc(100% - 6.25rem);
                background: linear-gradient(135deg, #1E5AD7 0.46%, #0B0B80 99.53%);
            }
        }

        .culture {
            margin: 0 -1.333rem;
            padding-bottom: 4rem;

            &-item {
                width: 86%;
                ;
            }
        }
    }

    /deep/ .v-modal {
        opacity: 0.8;

    }

    /deep/ .image-preview-dialog {
        width: 100% !important;
        height: auto !important;
        padding: 0 1rem;
        background: transparent;

        .el-dialog__body {
            padding: 0;
            background: #000;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
        }

        .el-dialog__header {
            padding: 0;
            background: transparent;
            position: relative;
            z-index: 1;
        }

        .el-dialog__headerbtn {
            top: 20px;
            right: 20px;
            color: #fff;
            z-index: 2;
            position: fixed;

            .el-icon-close {
                color: white;
            }
        }

        .image-container {
            width: 100%;
            aspect-ratio: 16/9;
            position: relative;
            overflow: hidden;
            display: flex;
            justify-content: center;
            align-items: center;

            img {
                max-width: 100%;
                max-height: 100%;
                width: auto;
                height: auto;
                object-fit: contain;
            }
        }
    }
}
</style>